<template>
  <div class="cont" id="brandClassroom5">
    <div class="inner">
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
        style="height:31px;width:78px;margin-left:39px;margin-bottom:13px"
        :src="require('@/assets/image/brandClassroom/brandClassroom5/img1.png')"
        :fit="fit"
      ></el-image>
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
        style="height:16px;width:108px;margin-left:27px;margin-bottom: 31px"
        :src="require('@/assets/image/brandClassroom/brandClassroom5/img2.png')"
        :fit="fit"
      ></el-image>
      
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
        style="height:26px;width:122px;margin-left:0px;margin-bottom:0px"
        :src="require('@/assets/image/brandClassroom/brandClassroom5/img3.png')"
        :fit="fit"
      ></el-image>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fit: "cover",
      animate: false,
      screenHeight: window.innerHeight || document.documentElement.clientHeight
    };
  },
  mounted() {
    // 事件监听滚动条
    window.addEventListener("scroll", this.watchScroll);
    var scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    var topPos = document.getElementById("brandClassroom5").offsetTop;

    if (scrollTop + this.screenHeight > topPos) {
      this.animate = true;
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.watchScroll);
  },
  methods: {
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var topPos = document.getElementById("brandClassroom5").offsetTop;
      if (scrollTop + this.screenHeight > topPos) {
        this.animate = true;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  height: 368px;
  background-color: pink;
  color: #fff;
  margin: 0 auto;
  position: relative;
  background: url('~@/assets/image/brandClassroom/brandClassroom5/bg.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.inner {
  position: absolute;
  width: 189px;
  height: 117px;
  right: 233px;
  top: 126px;
}
</style>